// Deprecated

'use strict';

module.exports = function (obj) { return typeof obj === 'function'; };



//////////////////
// WEBPACK FOOTER
// ./~/event-emitter/~/es5-ext/object/is-callable.js
// module id = 25
// module chunks = 0